
import _ from 'underscore'
import store from '../state/store'

store.on('inbox:opened', function() {
  store.get().ui.notifications.set({unreads: false})
})

store.on('inbox:notification', function() {
  store.get().ui.notifications.set({unreads: true})
})